import getIdempotenceKey from '../../../../../../../utils/getIdempotenceKey';
import trim from "mn-utils/trim";
import {apiV2PayByLinkCreate, apiV2PayByLinkUpdate} from "../../../../../../../api/merchant/payByLink";

export default (data, id) => {
  const {
    customer,
    invoice,
    company,
    address,
    email,
    retailer_mail,
    phone,
    amount,
    currency,
    files = [],
    expirationDate,
    description
  } = data;

  const params = {
    idempotence_key: getIdempotenceKey(),
    buyer_name: customer,
    invoice_number: invoice,
    company: trim(company),
    address: trim(address),
    email: email,
    retailer_mail: retailer_mail || null,
    phone: trim(phone),
    amount: amount,
    fiat_code: currency,
    expired_at: expirationDate,
    files: files.map((el) => el.id),
    description: trim(description),

    skipError: true
  };

  if (!id) {
    return apiV2PayByLinkCreate(params);
  }

  return apiV2PayByLinkUpdate({id, ...params});
}
